// Complete MagicLink component with styling

import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import './MagicLink.css';

const MagicLink = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('verifying');
  const [error, setError] = useState('');

  useEffect(() => {
    const verifyMagicLink = async () => {
      const token = searchParams.get('token');
      
      if (!token) {
        setStatus('error');
        setError('Invalid magic link');
        return;
      }

      try {
        const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:5001';
        const response = await axios.get(`${apiUrl}/api/auth/magic-link?token=${token}`);
        
        if (response.data.success) {
          // Store auth data
          localStorage.setItem('token', response.data.token);
          localStorage.setItem('user', JSON.stringify(response.data.user));
          
          setStatus('success');
          
          // Redirect to dashboard after 2 seconds
          setTimeout(() => {
            navigate('/dashboard');
          }, 2000);
        }
      } catch (err) {
        setStatus('error');
        setError(err.response?.data?.error || 'Failed to verify email');
      }
    };

    verifyMagicLink();
  }, [searchParams, navigate]);

  return (
    <div className="magic-link-wrapper">
      <div className="magic-link-container">
        {status === 'verifying' && (
          <div className="magic-link-content verifying">
            <div className="magic-spinner">
              <div className="spinner-ring"></div>
              <div className="spinner-ring"></div>
              <div className="spinner-ring"></div>
            </div>
            <h2>Verifying your email...</h2>
            <p>Please wait while we confirm your account</p>
            <div className="progress-bar">
              <div className="progress-fill"></div>
            </div>
          </div>
        )}
        
        {status === 'success' && (
          <div className="magic-link-content success">
            <div className="success-animation">
              <svg className="checkmark" viewBox="0 0 52 52">
                <circle className="checkmark-circle" cx="26" cy="26" r="25" fill="none"/>
                <path className="checkmark-check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/>
              </svg>
            </div>
            <h2>Email Verified!</h2>
            <p className="success-message">Your account has been activated successfully</p>
            <p className="redirect-message">Redirecting to your dashboard...</p>
            <div className="dots-loading">
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
        )}
        
        {status === 'error' && (
          <div className="magic-link-content error">
            <div className="error-icon">
              <svg viewBox="0 0 24 24" fill="none">
                <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/>
                <path d="M15 9L9 15M9 9L15 15" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
              </svg>
            </div>
            <h2>Verification Failed</h2>
            <p className="error-message">{error}</p>
            <div className="error-actions">
              <button 
                className="btn-primary"
                onClick={() => navigate('/register')}
              >
                Back to Registration
              </button>
              <button 
                className="btn-secondary"
                onClick={() => navigate('/')}
              >
                Go to Homepage
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default MagicLink;